<div id="modal-content-wrapper">
  <header id="modal-header">
    <h1 i18n  id="modal-title">Select Background</h1>
  </header>
  <section id="modal-body">
    <div class="selection-group">
      <button i18n [class]="type=='public'  ? 'active' : ''" (click)="changeType('public')">Public Gallery</button>
      <button i18n [class]="type=='private' ? 'active' : ''" (click)="changeType('private')">My Gallery</button>
      <button i18n [class]="type=='color'   ? 'active' : ''" (click)="changeType('color')">Color</button>
      <button i18n [class]="type=='default'   ? 'active' : ''" (click)="changeType('default')">Default</button>
      <!-- <mat-radio-group aria-label="Select an option" [(ngModel)]="type">
        <mat-grid-list cols="4" rowHeight="100px">
          <mat-grid-tile></mat-grid-tile>
          <mat-grid-tile>
            <mat-radio-button i18n value="image" style="font-size: 20px;">&nbsp;Image</mat-radio-button>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-radio-button i18n value="color" style="font-size: 20px;">&nbsp;Color</mat-radio-button>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-tile></mat-grid-tile>
      </mat-radio-group> -->
    </div>

    <div *ngIf="type == 'public'">
      <div class="preview">
        <div class="container image-detail">
          <div class="row">
            <h2 i18n>Public Gallery</h2>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <img [src]="sanitizeImageUrl(selectedImg)" class="img-preview">
            </div>
          </div>
        </div>
      </div>

      <div class="img-list">
        <div class="container image-detail">
          <div class="row img-group">
            <div class="col-sm-3 col-xs-3" *ngFor="let img of mini_imgList; let i = index" style="text-align: center;">
              <img [src]="sanitizeImageUrl(img)" class="img-item" (click)='selectImage(i)'>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="type == 'private'">
      <div class="preview">
        <div class="container image-detail">
          <div class="row">
            <h2 i18n>My Gallery</h2>
            <button i18n class="uploadbtn" (click)="setBackground()">Upload</button>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <img [src]="sanitizeImageUrl(selectedImg)" *ngIf="initPrivate" class="img-preview">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="type == 'color'">
      <div class="preview">
        <div class="container image-detail">
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <canvas class="img-preview" [style.background-color]="backgroundColorCtr.value?.rgba"></canvas>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-sm-12 col-xs-12">
              <mat-form-field class="col-12">
                <mat-label i18n>Background Color</mat-label>
                <input matInput [ngxMatColorPicker]="picker" [formControl]="backgroundColorCtr" autocomplete='false'>
                <ngx-mat-color-toggle matSuffix [for]="picker"></ngx-mat-color-toggle>
                <ngx-mat-color-picker #picker [touchUi]="touchUi" [color]="color"></ngx-mat-color-picker>


              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
  <footer id="modal-footer">
    <button i18n mat-raised-button id="modal-action-button"
      [mat-dialog-close]="type=='default' ? 'transparent' : type!='color' ? selectedImg : '#' + backgroundColorCtr.value?.hex">
      Save
    </button>
    <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
      Close
    </button>
  </footer>
</div>